import React from 'react';
import { FormData } from '../types';

interface ButtonInputProps {
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
}

const ButtonInput: React.FC<ButtonInputProps> = ({ formData, setFormData }) => {
  const handleButtonTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData(prev => ({
      ...prev,
      buttonText: e.target.value
    }));
  };

  const handleButtonLinkChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData(prev => ({
      ...prev,
      buttonLink: e.target.value
    }));
  };

  return (
    <div className="button-inputs">
      <div className="input-group">
        <label>🔘 Button Label</label>
        <input
          type="text"
          value={formData.buttonText}
          onChange={handleButtonTextChange}
          placeholder='e.g., "Download App"'
          maxLength={20}
        />
      </div>
      <div className="input-group">
        <label>🔗 Button Link</label>
        <input
          type="url"
          value={formData.buttonLink}
          onChange={handleButtonLinkChange}
          placeholder="e.g. https://myapp.com"
        />
      </div>
    </div>
  );
};

export default ButtonInput; 